import { render, staticRenderFns } from "./AddRoleDialog.vue?vue&type=template&id=34b0bec4"
import script from "./AddRoleDialog.vue?vue&type=script&lang=js"
export * from "./AddRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports